// Contrato público de la página de detalle de artista. Refleja la
// proyección que la API local hace de `GET /artists/{id}` del Core
// (B2C autenticado). La página se carga por el id que va en el slug
// `{id}-{slug-nombre}`.
import { z } from 'zod';

export const ArtistPublicSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string().optional(),
  // Descripción en HTML (el Core la entrega así). La web la renderiza
  // saneada (`safe-html`).
  description: z.string().optional(),
  imageUrl: z.string().optional(),
});

export type ArtistPublic = z.infer<typeof ArtistPublicSchema>;

// Item del listado público de artistas (para el sitemap). La URL del
// detalle usa el `slug` si existe; si no, el `id`.
export const ArtistListItemSchema = z.object({
  id: z.string(),
  slug: z.string().optional(),
});
export const ArtistsListResponseSchema = z.object({
  items: z.array(ArtistListItemSchema),
});
export type ArtistListItem = z.infer<typeof ArtistListItemSchema>;
export type ArtistsListResponse = z.infer<typeof ArtistsListResponseSchema>;
